export default __webpack_public_path__ + "static/media/about4.73f0f2e1.png";